module.exports = __webpack_public_path__ + "img/ecological-local-lore.dd675082.jpg";